import { defineStore } from "pinia";

interface State {
  keywords: string[];
  keywordsModalOpened: boolean;
  longText: string;
  loading: boolean;
}

export const useKeywordsStore = defineStore("keywordsStore", {
  state: (): State => ({
    keywords: [],
    keywordsModalOpened: false,
    longText: "",
    loading: false,
  }),

  actions: {
    setKeywords(keywordsIn: string[]) {
      this.keywords = keywordsIn;
    },
  },
});
